<template>
    <div class="space-y-6 text-center mb-14">
        <p>{{ $t('inventory.product.import_form.content.file.select') }}</p>
        <ContactContactPreviewTable :clients="importedFile?.lines" />
    </div>
    <div :class="$theme('modal.footer.button_container')">
        <LoadingButton
            :extra-class-name="$theme('modal.footer.button')"
            :class-name="$theme('button.style.cancel')"
            prevent-default
            @click="$emit('previous')"
            >{{ $t('misc.back') }}</LoadingButton
        >
        <LoadingButton
            :loading="loading"
            :extra-class-name="$theme('modal.footer.button')"
            :class="'cursor-pointer'"
            @clicked="$emit('upload')"
            >{{ $t('actions.upload') }}</LoadingButton
        >
    </div>
</template>
<script setup lang="ts">
    import ImportedFile from '../../../app/common/models/ImportedFile';

    const props = defineProps<{
        loading: boolean;
        haveFileSelected: boolean;
        importedFile: ImportedFile | null | undefined;
    }>();

    defineEmits<{
        (e: 'previous'): void;
        (e: 'upload'): void;
    }>();
</script>
